import { getInvoices, type InvoiceFilterDto } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { useQuery } from "@tanstack/react-query";

export const getInvoiceListQueryKey = (filter: InvoiceFilterDto) => [
	"INVOICE_LIST",
	filter.invoiceNumber,
	filter.variableSymbol,
	filter.status,
	filter.partnerId,
	filter.marketId,
	filter.verticals,
	filter.pageLimit,
	filter.pageIndex,
];

export function useInvoiceList(filter: InvoiceFilterDto) {
	return useQuery({
		queryKey: getInvoiceListQueryKey(filter),
		queryFn: processResponse(() =>
			getInvoices(
				filter.invoiceNumber,
				filter.variableSymbol,
				filter.status ?? undefined,
				filter.partnerId,
				filter.marketId,
				filter.verticals,
				filter.pageLimit,
				filter.pageIndex,
			),
		),
		retry: false,
		refetchInterval: false,
		refetchIntervalInBackground: false,
	});
}
